<div class="row">
  @for (n of data2show; track n) {
    <div class="col-md-3">
      <a href="{{n.newslink}}" target="_blank">
        <div class="news-img" style="background-image:url('{{n.newsimage}}');"></div>
        <div class="pt-2"><b>{{n.newstitle}}</b></div>
        <div class="news-date pb-2">{{n.newsdate | date:'MMMM d, yyyy'}}</div>
        <p>{{n.newssummary}}</p>
      </a>
    </div>
  }
</div>
@if (limit>4 && data.length > data2show.length) {
  <div class="text-center">
    <hr>
      <button (click)="loadMore()" class="btn btn-outline-primary d-print-none mt-5">Load More</button>
    </div>
  }